import а from "../../assets/ukraineAudio/а.mp3";
import б from "../../assets/ukraineAudio/б.mp3";
import в from "../../assets/ukraineAudio/в.mp3";
import г from "../../assets/ukraineAudio/г.mp3";
import ґ from "../../assets/ukraineAudio/ґ.mp3";
import д from "../../assets/ukraineAudio/д.mp3";
import е from "../../assets/ukraineAudio/е.mp3";
import є from "../../assets/ukraineAudio/є.mp3";
import ж from "../../assets/ukraineAudio/ж.mp3";
import з from "../../assets/ukraineAudio/з.mp3";
import и from "../../assets/ukraineAudio/и.mp3";
import і from "../../assets/ukraineAudio/і.mp3";
import ї from "../../assets/ukraineAudio/ї.mp3";
import й from "../../assets/ukraineAudio/й.mp3";
import к from "../../assets/ukraineAudio/к.mp3";
import л from "../../assets/ukraineAudio/л.mp3";
import м from "../../assets/ukraineAudio/м.mp3";
import н from "../../assets/ukraineAudio/н.mp3";
import о from "../../assets/ukraineAudio/о.mp3";
import п from "../../assets/ukraineAudio/п.mp3";
import р from "../../assets/ukraineAudio/р.mp3";
import с from "../../assets/ukraineAudio/с.mp3";
import т from "../../assets/ukraineAudio/т.mp3";
import у from "../../assets/ukraineAudio/у.mp3";
import ф from "../../assets/ukraineAudio/ф.mp3";
import х from "../../assets/ukraineAudio/х.mp3";
import ц from "../../assets/ukraineAudio/ц.mp3";
import ч from "../../assets/ukraineAudio/ч.mp3";
import ш from "../../assets/ukraineAudio/ш.mp3";
import щ from "../../assets/ukraineAudio/щ.mp3";
import ь from "../../assets/ukraineAudio/ь.mp3";
import ю from "../../assets/ukraineAudio/ю.mp3";
import я from "../../assets/ukraineAudio/я.mp3";

import ананас from "../../assets/ukraineAudio/ананас.mp3";
import банан from "../../assets/ukraineAudio/банан.mp3";
import вовк from "../../assets/ukraineAudio/вовк.mp3";
import груша from "../../assets/ukraineAudio/груша.mp3";
import ґудзик from "../../assets/ukraineAudio/ґудзик.mp3";
import дракон from "../../assets/ukraineAudio/дракон.mp3";
import екскаватор from "../../assets/ukraineAudio/екскаватор.mp3";
import єнот from "../../assets/ukraineAudio/єнот.mp3";
import жираф from "../../assets/ukraineAudio/жираф.mp3";
import заєць from "../../assets/ukraineAudio/заєць.mp3";
import индик from "../../assets/ukraineAudio/индик.mp3";
import інопланетян from "../../assets/ukraineAudio/інопланетян.mp3";
import їжачок from "../../assets/ukraineAudio/їжачок.mp3";
import йогурт from "../../assets/ukraineAudio/йогурт.mp3";
import корова from "../../assets/ukraineAudio/корова.mp3";
import лимон from "../../assets/ukraineAudio/лимон.mp3";
import машина from "../../assets/ukraineAudio/машина.mp3";
import нитка from "../../assets/ukraineAudio/нитка.mp3";
import огірок from "../../assets/ukraineAudio/огірок.mp3";
import папуга from "../../assets/ukraineAudio/папуга.mp3";
import рак from "../../assets/ukraineAudio/рак.mp3";
import сонце from "../../assets/ukraineAudio/сонце.mp3";
import тигр from "../../assets/ukraineAudio/тигр.mp3";
import устриця from "../../assets/ukraineAudio/устриця.mp3";
import фламінго from "../../assets/ukraineAudio/фламінго.mp3";
// eslint-disable-next-line
import хом_як from "../../assets/ukraineAudio/хом\'як.mp3";
import цуценя from "../../assets/ukraineAudio/цуценя.mp3";
import черепаха from "../../assets/ukraineAudio/черепаха.mp3";
import шишка from "../../assets/ukraineAudio/шишка.mp3";
import щука from "../../assets/ukraineAudio/щука.mp3";
import юла from "../../assets/ukraineAudio/юла.mp3";
import ялинка from "../../assets/ukraineAudio/ялинка.mp3";

//images
import bananaPng from './icons/banana.png';
import wolfPng from './icons/wolf.png';
import pineapplePng from './icons/pineapple.png';
import pearPng from './icons/pear.png';
import buttonPng from './icons/button.png';
import dragonPng from './icons/dragon.png';
import excavatorPng from './icons/excavator.png';
import raccoonPng from './icons/raccoon.png';
import giraffePng from './icons/giraffe.png';
import harePng from './icons/hare.png';
import turkeyPng from './icons/turkey.png';
import alienPng from './icons/alien.png';
import hedgehogPng from './icons/hedgehog.png';
import yogurtPng from './icons/yogurt.png';
import cowPng from './icons/cow.png';
import lemonPng from './icons/lemon.png';
import carPng from './icons/car.png';
import threadSpoolPng from './icons/thread-spool.png';
import cucumberPng from './icons/cucumber.png';
import parrotPng from './icons/parrot.png';
import crayfishPng from './icons/crayfish.png';
import sunPng from './icons/sunny.png';
import tigerPng from './icons/tiger.png';
import pearlPng from './icons/pearl.png';
import flamingoPng from './icons/flamingo.png';
import hamsterPng from './icons/hamster.png';
import pappyPng from './icons/pappy.png';
import turtlePng from './icons/turtle.png';
import pineConePng from './icons/pine-cone.png';
import pikePng from './icons/pike.png';
import ьPng from './icons/ь.png';
import юлаPng from './icons/юла.png';
import christmasTreePng from './icons/christmas-tree.png';

export const ukraineAlphabet = [
  {
    letter: "А",
    color: "#F06543",
    src: pineapplePng,
    name: "Ананас",
  },
  {
    letter: "Б",
    color: "#F99B28",
    src: bananaPng,
    name: "Банан",
  },
  {
    letter: "В",
    color: "#FEF723",
    src: wolfPng,
    name: "Вовк",
  },
  {
    letter: "Г",
    color: "#B5D444",
    src: pearPng,
    name: "Груша",
  },
  {
    letter: "Ґ",
    color: "#0AADE8",
    src: buttonPng,
    name: "Ґудзик",
  },
  {
    letter: "Д",
    color: "#EA259D",
    src: dragonPng,
    name: "Дракон",
  },
  {
    letter: "Е",
    color: "#363190",
    src: excavatorPng,
    name: "Екскаватор",
  },
  {
    letter: "Є",
    color: "#F9403C",
    src: raccoonPng,
    name: "Єнот",
  },
  {
    letter: "Ж",
    color: "#F5901E",
    src: giraffePng,
    name: "Жираф",
  },
  {
    letter: "З",
    color: "#FFF11A",
    src: harePng,
    name: "Заєць",
  },
  {
    letter: "И",
    color: "#B7D340",
    src: turkeyPng,
    name: "Индик",
  },
  {
    letter: "І",
    color: "#0AADE9",
    src: alienPng,
    name: "Інопланетян",
  },
  {
    letter: "Ї",
    color: "#EA008D",
    src: hedgehogPng,
    name: "Їжачок",
  },
  {
    letter: "Й",
    color: "#2E2B92",
    src: yogurtPng,
    name: "Йогурт",
  },
  {
    letter: "К",
    color: "#B7D340",
    src: cowPng,
    name: "Корова",
  },
  {
    letter: "Л",
    color: "#0AADE9",
    src: lemonPng,
    name: "Лимон",
  },
  {
    letter: "М",
    color: "#EA008D",
    src: carPng,
    name: "Машина",
  },
  {
    letter: "Н",
    color: "#2E2B92",
    src: threadSpoolPng,
    name: "Нитка",
  },
  {
    letter: "О",
    color: "#B7D340",
    src: cucumberPng,
    name: "Огірок",
  },
  {
    letter: "П",
    color: "#F59120",
    src: parrotPng,
    name: "Папуга",
  },
  {
    letter: "Р",
    color: "#F8EA13",
    src: crayfishPng,
    name: "Рак",
  },
  {
    letter: "С",
    color: "#B3D43A",
    src: sunPng,
    name: "Сонце",
  },
  {
    letter: "Т",
    color: "#04ACE4",
    src: tigerPng,
    name: "Тигр",
  },
  {
    letter: "У",
    color: "#D9077D",
    src: pearlPng,
    name: "Устриця",
  },
  {
    letter: "Ф",
    color: "#2E2E8C",
    src: flamingoPng,
    name: "Фламінго",
  },
  {
    letter: "Х",
    color: "#ED3131",
    src: hamsterPng,
    name: "Хом'як",
  },
  {
    letter: "Ц",
    color: "#F7901B",
    src: pappyPng,
    name: "Цуценя",
  },
  {
    letter: "Ч",
    color: "#F9F506",
    src: turtlePng,
    name: "Черепаха",
  },
  {
    letter: "Ш",
    color: "#B7D64A",
    src: pineConePng,
    name: "Шишка",
  },
  {
    letter: "Щ",
    color: "#02AFE8",
    src: pikePng,
    name: "Щука",
  },
  {
    letter: "Ь",
    color: "#F06543",
    src: ьPng,
    name: "Ь",
  },
  {
    letter: "Ю",
    color: "#F99B28",
    src: юлаPng,
    name: "Юла",
  },
  {
    letter: "Я",
    color: "#FEF723",
    src: christmasTreePng,
    name: "Ялинка",
  },
];

export const audioUkraineAlphabet = {
  А: а,
  Б: б,
  В: в,
  Г: г,
  Ґ: ґ,
  Д: д,
  Е: е,
  Є: є,
  Ж: ж,
  З: з,
  И: и,
  І: і,
  Ї: ї,
  Й: й,
  К: к,
  Л: л,
  М: м,
  Н: н,
  О: о,
  П: п,
  Р: р,
  С: с,
  Т: т,
  У: у,
  Ф: ф,
  Х: х,
  Ц: ц,
  Ч: ч,
  Ш: ш,
  Щ: щ,
  Ь: ь,
  Ю: ю,
  Я: я,
  Ананас: ананас,
  Банан: банан,
  Вовк: вовк,
  Груша: груша,
  Ґудзик: ґудзик,
  Дракон: дракон,
  Екскаватор: екскаватор,
  Єнот: єнот,
  Жираф: жираф,
  Заєць: заєць,
  Индик: индик,
  Інопланетян: інопланетян,
  Їжачок: їжачок,
  Йогурт: йогурт,
  Корова: корова,
  Лимон: лимон,
  Машина: машина,
  Нитка: нитка,
  Огірок: огірок,
  Папуга: папуга,
  Рак: рак,
  Сонце: сонце,
  Тигр: тигр,
  Устриця: устриця,
  Фламінго: фламінго,
  // eslint-disable-next-line
  [`Хом\'як`]: хом_як,
  Цуценя: цуценя,
  Черепаха: черепаха,
  Шишка: шишка,
  Щука: щука,
  Юла: юла,
  Ялинка: ялинка,
};
